import { fetchers } from "@/services/api/fetchers";
import { DailyStatsRes, UpdateStreakRes } from "@/services/api/fetchers/daily-user-stats";
import { StateCreator } from "zustand";
import { BoundStore } from "./index";

export interface DailyStatsSlice {
  dailyStats: {
    today: DailyStatsRes | null;
    yesterday: DailyStatsRes | null;
    fetchDailyStats: (userId: string, period: "today" | "yesterday") => Promise<DailyStatsRes>;
    updateStreak: () => Promise<UpdateStreakRes>;
  };
}

const createDailyStatsSlice: StateCreator<BoundStore, [], [], DailyStatsSlice> = (set) => ({
  dailyStats: {
    today: null,
    yesterday: null,

    fetchDailyStats: async (userId, period) => {
      try {
        const date = new Date();
        if (period === "yesterday") {
          date.setDate(date.getDate() - 1);
        }

        // Format date as YYYY-MM-DD
        const dateString = date.toLocaleDateString("en-CA");

        const stats = await fetchers.dailyUserStats.getDailyStats(userId, dateString);
        set((state) => ({
          dailyStats: {
            ...state.dailyStats,
            [period]: stats,
          },
        }));
        return stats;
      } catch (error) {
        console.error(`Failed to fetch daily stats for ${period}:`, error);
        return {
          current_streak: 0,
          longest_streak: 0,
          notes_written: 0,
          todos_completed: 0,
        };
      }
    },

    updateStreak: async () => {
      try {
        const result = await fetchers.dailyUserStats.updateStreak();
        set((state) => ({
          dailyStats: {
            ...state.dailyStats,
            today: {
              current_streak: result.current_streak,
              longest_streak: result.longest_streak,
              notes_written: state.dailyStats.today?.notes_written ?? 0,
              todos_completed: state.dailyStats.today?.todos_completed ?? 0,
            },
          },
        }));
        return result;
      } catch (error) {
        console.error("Failed to update streak:", error);
        throw error;
      }
    },
  },
});

export default createDailyStatsSlice;
